import { render, staticRenderFns } from "./AlertWrapper.vue?vue&type=template&id=165a74bd"
import script from "./AlertWrapper.vue?vue&type=script&lang=js"
export * from "./AlertWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('165a74bd')) {
      api.createRecord('165a74bd', component.options)
    } else {
      api.reload('165a74bd', component.options)
    }
    module.hot.accept("./AlertWrapper.vue?vue&type=template&id=165a74bd", function () {
      api.rerender('165a74bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home/AlertWrapper.vue"
export default component.exports